module.exports = __webpack_public_path__ + "static/media/Rectangle 34.2e7cd37a.svg";